import script from "./DetailProductInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailProductInfo.vue?vue&type=script&lang=ts&setup=true"

import "./DetailProductInfo.vue?vue&type=style&index=0&id=bdde6a38&lang=css"

const __exports__ = script;

export default __exports__